export const helpContent = {
  // Category operations
  'add-category': {
    simple: 'Add category',
    detailed: 'Create a new category to organize your content. Categories can contain subcategories and content items.'
  },
  'add-category-disabled': {
    simple: 'Cannot add category',
    detailed: 'Categories with content cannot have subcategories. Add content to the subcategories instead, or flatten this category first.'
  },
  'delete-category': {
    simple: 'Delete category',
    detailed: 'Remove this category and all its contents. This action cannot be undone, so make sure you want to delete this category.'
  },
  'delete-category-disabled': {
    simple: 'Cannot delete category',
    detailed: 'No categories are currently selected. Select one or more categories to delete them.'
  },
  'rename-category': {
    simple: 'Rename category',
    detailed: 'Change the name of this category. This helps organize and identify your categories more easily.'
  },
  'rename-category-disabled': {
    simple: 'Cannot rename category',
    detailed: 'No category is currently selected. Select a category to rename it.'
  },
  'move-category': {
    simple: 'Move category',
    detailed: 'Relocate this category to a different position in the hierarchy. You can move it up, down, or into another category as a subcategory.'
  },
  'move-category-up': {
    simple: 'Move category up',
    detailed: 'Move the selected category up in the list. This changes the order within the same parent category.'
  },
  'move-category-down': {
    simple: 'Move category down',
    detailed: 'Move the selected category down in the list. This changes the order within the same parent category.'
  },
  'move-category-up-disabled': {
    simple: 'Cannot move category',
    detailed: 'No categories are selected or the selected categories cannot be moved in this direction. Check your selection and try a different direction.'
  },
    'move-category-down-disabled': {
      simple: 'Cannot move category',
      detailed: 'No categories are selected or the selected categories cannot be moved in this direction. Check your selection and try a different direction.'
  },
  'move-content-up': {
   simple: 'Move content up',
   detailed: 'Move the selected content up in the list. This changes the order within the same parent category.'
 },
  'move-content-down': {
     simple: 'Move content down',
     detailed: 'Move the selected content down in the list. This changes the order within the same parent category.'
 },
   'move-content-up-disabled': {
     simple: 'Cannot move content',
     detailed: 'No contents are selected or the selected contents cannot be moved in this direction. Check your selection and try a different direction.'
 },
 'move-content-down-disabled': {
     simple: 'Cannot move content',
     detailed: 'No contents are selected or the selected contents cannot be moved in this direction. Check your selection and try a different direction.'
  },
  'copy-category': {
    simple: 'Copy category',
    detailed: 'Create a duplicate of this category with all its contents. The copied category will be placed in your clipboard for pasting elsewhere.'
  },
  'copy-category-disabled': {
    simple: 'Cannot copy category',
    detailed: 'No categories are currently selected. Select one or more categories to copy them.'
  },
  'cut-category': {
    simple: 'Cut category',
    detailed: 'Remove this category from its current location and place it in your clipboard. You can then paste it elsewhere in the document.'
  },
  'cut-category-disabled': {
    simple: 'Cannot cut category',
    detailed: 'No categories are currently selected. Select one or more categories to cut them.'
  },
  'paste-category': {
    simple: 'Paste category',
    detailed: 'Insert a previously copied or cut category at this location. The category will maintain its structure and all contained content.'
  },
  'paste-category-disabled': {
    simple: 'Cannot paste category',
    detailed: 'No category is currently in your clipboard. Copy or cut a category first, then paste it here.'
  },
  
  // Content operations
  'add-content': {
    simple: 'Add content',
    detailed: 'Create a new content item in this category. Content items contain the actual text and are organized by subcases for easy reference.'
  },
  'add-content-disabled': {
    simple: 'Cannot add content',
    detailed: 'Categories with subcategories cannot contain content directly. Add content to the subcategories instead, or flatten this category first.'
  },
  'edit-content': {
    simple: 'Edit content',
    detailed: 'Modify the text content of this item. You can update the subcase name and the main text content. Changes are saved automatically.'
  },
  'edit-content-disabled': {
    simple: 'Cannot edit content',
    detailed: 'No content is currently selected for editing. Select a single content item first.'
  },
  'delete-content': {
    simple: 'Delete content',
    detailed: 'Remove this content item from the category. This action cannot be undone, so make sure you want to delete this content.'
  },
  'delete-content-disabled': {
    simple: 'Cannot delete content',
    detailed: 'No content is currently selected. Select one or more content items to delete them.'
  },
  
  // Document operations
  'document-menu': {
    simple: 'Document menu',
    detailed: 'Access document management operations including creating, opening, closing, and organizing your documents.'
  },
  'new-document': {
    simple: 'New document',
    detailed: 'Create a new empty document. You can start building your category structure from scratch with this option.'
  },
  'open-document': {
    simple: 'Open document',
    detailed: 'Open the selected document in a new tab for editing. This allows you to work with multiple documents simultaneously.'
  },
  'open-document-disabled': {
    simple: 'Cannot open document',
    detailed: 'The selected document is already open in a tab. You can only open each document once.'
  },
  'close-document': {
    simple: 'Close document',
    detailed: 'Close the currently open document tab. This will save your work and remove the document from the active tabs.'
  },
  'close-document-disabled': {
    simple: 'Cannot close document',
    detailed: 'No document is currently open in a tab. Select a document and open it first.'
  },
  'delete-document': {
    simple: 'Delete document',
    detailed: 'Permanently remove the selected document from your account. This action cannot be undone.'
  },
  'delete-document-disabled': {
    simple: 'Cannot delete document',
    detailed: 'No document is selected for deletion. Select a document from the list first.'
  },
  'rename-document': {
    simple: 'Rename document',
    detailed: 'Change the name of the selected document. This helps organize and identify your documents more easily.'
  },
  'rename-document-disabled': {
    simple: 'Cannot rename document',
    detailed: 'No document is selected for renaming. Select a document from the list first.'
  },
  'duplicate-document': {
    simple: 'Duplicate document',
    detailed: 'Create a copy of the selected document with a new name. You can choose which subcases to include in the duplicate.'
  },
  'duplicate-document-disabled': {
    simple: 'Cannot duplicate document',
    detailed: 'No document is selected for duplication. Select a document from the list first.'
  },
  'merge-document': {
    simple: 'Merge document',
    detailed: 'Combine two documents into one. You can choose how to handle conflicts and missing content during the merge.'
  },
  'merge-document-disabled': {
    simple: 'Cannot merge document',
    detailed: 'No document is selected for merging. Select a document from the list first.'
  },
  'merge-document-from': {
    simple: 'Merge from document',
    detailed: 'Select the source document to merge content from. This document will provide the content that gets merged into the current document.'
  },
  'merge-document-new': {
    simple: 'Merge into new document',
    detailed: 'Create a new document instead of merging into the current one. This preserves both original documents and creates a combined version.'
  },
  'merge-document-name': {
    simple: 'New document name',
    detailed: 'Enter a name for the new document that will be created from the merge. This name must be unique among your documents.'
  },
  'merge-document-missing-resolution': {
    simple: 'Missing content resolution',
    detailed: 'Choose how to handle content that exists in the source document but not in the target: Copy (add missing content), Skip (ignore missing content), or Abort (stop the merge).'
  },
  'merge-document-type-resolution': {
    simple: 'Type mismatch resolution',
    detailed: 'Choose how to handle conflicts when content types don\'t match between documents: Keep (preserve target content), Skip (ignore conflicting content), or Abort (stop the merge).'
  },
  'merge-document-merge': {
    simple: 'Merge documents',
    detailed: 'Execute the merge operation with the selected settings. This will combine the documents according to your resolution preferences.'
  },
  'merge-document-merge-disabled': {
    simple: 'Cannot merge documents',
    detailed: 'Please select a source document to merge from and ensure all required fields are filled correctly.'
  },
  'generate-subtree': {
    simple: 'Generate subtree from content',
    detailed: 'Use AI to analyze the content of this category and suggest a hierarchical structure. The AI will organize the content into logical subcategories.'
  },
  'generate-subtree-disabled': {
    simple: 'Cannot generate subtree',
    detailed: 'This feature is only available for content categories that contain text content. Select a category with content to generate a subtree.'
  },
  'subtree-depth': {
    simple: 'Maximum depth',
    detailed: 'Set the maximum number of levels deep the generated subtree can be. Higher values create more detailed hierarchies but may be more complex to manage.'
  },
  'subtree-preview-content': {
    simple: 'Show content preview',
    detailed: 'Display a preview of the content that will be included in each category of the generated subtree. This helps you understand how the AI has organized your content.'
  },
  'subtree-use-suggested-name': {
    simple: 'Use AI-suggested name',
    detailed: 'Replace the current category name with the AI-suggested name. This is only available for non-root categories and can help improve the overall structure.'
  },
  'subtree-save-with-content': {
    simple: 'Generate with Content',
    detailed: 'Create the complete subtree structure including all categories and their associated content. Original content is deleted and recreated in the new structure.'
  },
  'subtree-save-structure-only': {
    simple: 'Generate Structure Only',
    detailed: 'Create only the category structure without content nodes. Original content is preserved in a temporary category for manual organization.'
  },
  'subtree-retry': {
    simple: 'Retry with different depth',
    detailed: 'Generate a new subtree structure with the current maximum depth setting. This is useful if you want to try different depth levels to get better organization.'
  },
  'subtree-max-depth': {
    simple: 'Maximum tree depth',
    detailed: 'Set the maximum number of levels deep the generated subtree can be. Higher values create more detailed hierarchies but may be more complex to manage.'
  },
  'suggest-tree': {
    simple: 'Suggest category tree from files',
    detailed: 'Select one or more document files (PDF, Word, text, etc.) and let AI suggest a category structure based on the combined content. The system will analyze all files together to create a unified category tree. Great for organizing multiple related documents or large files.'
  },
  'suggest-tree-max-depth': {
    simple: 'Maximum tree depth',
    detailed: 'Set the maximum number of levels deep the suggested tree can be. Higher values create more detailed hierarchies but may be more complex to manage.'
  },
  'suggest-tree-show-content': {
    simple: 'Show content text',
    detailed: 'Display a preview of the content that will be included in each category of the suggested tree. This helps you understand how the AI has organized your content.'
  },
  'suggest-tree-subcase-name': {
    simple: 'Subcase name',
    detailed: 'Enter the subcase name that will be used for imported content. This helps organize content within categories.'
  },
  'suggest-tree-use-suggested-name': {
    simple: 'Use AI-suggested name',
    detailed: 'Use the AI-generated document name instead of a default name. The AI analyzes the content to suggest a meaningful name.'
  },
  'suggest-tree-context': {
    simple: 'Context input',
    detailed: 'Provide additional context to help the AI generate better category names and clustering. Examples include domain information, purpose, structure preferences, or key themes.'
  },
  'suggest-tree-proceed': {
    simple: 'Generate tree',
    detailed: 'Proceed with generating the category tree using the provided context and selected files.'
  },
  'suggest-tree-accept-with-content': {
    simple: 'Accept with content',
    detailed: 'Create a new document with the complete tree structure and all content. This preserves all the original content in the new organization.'
  },
  'suggest-tree-accept-tree-only': {
    simple: 'Accept tree only',
    detailed: 'Create a new document with the category structure and preserve original file content in a temporary category. This gives you the organization framework while keeping the original content accessible.'
  },
  'suggest-tree-custom-name': {
    simple: 'Custom document name',
    detailed: 'Enter a custom name for the document. If left empty, the AI-suggested name will be used. This allows you to provide a more descriptive or meaningful name for your document.'
  },
  'suggest-tree-retry': {
    simple: 'Retry with different settings',
    detailed: 'Generate a new suggested tree with the current maximum depth setting. This is useful if you want to try different parameters.'
  },
  'load-from-file': {
    simple: 'Load from file',
    detailed: 'Import a previously exported document (.nbr file) to restore your work or share documents between users.'
  },
  'export-to-file': {
    simple: 'Export to file',
    detailed: 'Export your document as a .nbr file for backup, sharing, or transferring to another system.'
  },
  'expand-document': {
    simple: 'Expand document with files',
    detailed: 'Select one or more files (PDF, Word, text, etc.) and use AI to expand the currently selected document with new categories and content based on the files.'
  },
  'expand-document-disabled': {
    simple: 'Cannot expand document',
    detailed: 'Select a document from the list first. Then you can expand it using one or more files.'
  },
  
  // Search and navigation
  'find-in-document': {
    simple: 'Find in document',
    detailed: 'Search for specific text within your document. You can search in category names, descriptions, and content. Supports exact, partial, and semantic search modes.'
  },
  'semantic-search': {
    simple: 'Semantic search',
    detailed: 'Search using natural language queries. The system understands meaning and context, not just exact text matches. Great for finding related content.'
  },
  
  // Settings and preferences
  'settings': {
    simple: 'Settings',
    detailed: 'Access application settings including auto-paste, tooltip font size, and help mode preferences.'
  },
  'auto-paste': {
    simple: 'Auto-paste from clipboard',
    detailed: 'Automatically paste content from your clipboard when adding new content to categories. This saves time when working with external text sources.'
  },
  'tooltip-font-size': {
    simple: 'Tooltip font size',
    detailed: 'Adjust the size of tooltip text to improve readability. Choose from small, medium, or large font sizes.'
  },
  'help-mode': {
    simple: 'Detailed help tooltips',
    detailed: 'Enable comprehensive help information in tooltips. When enabled, tooltips show detailed explanations of features and their usage.'
  },
  'short-tooltips': {
    simple: 'Short tooltips',
    detailed: 'Show brief tooltips for all UI elements, including text-based menu items. When disabled, only detailed help tooltips are shown when help mode is enabled.'
  },
  
  // General UI
  'undo': {
    simple: 'Undo',
    detailed: 'Reverse your last action. You can undo multiple actions in sequence to get back to a previous state.'
  },
  'undo-disabled': {
    simple: 'Cannot undo',
    detailed: 'No actions are available to undo. Perform some actions first to enable the undo feature.'
  },
  'redo': {
    simple: 'Redo',
    detailed: 'Reapply an action that was previously undone. Use this to restore changes you accidentally undid.'
  },
  'redo-disabled': {
    simple: 'Cannot redo',
    detailed: 'No actions are available to redo. Undo some actions first to enable the redo feature.'
  },
  'expand-all': {
    simple: 'Expand all',
    detailed: 'Open all collapsed categories to show the complete document structure at once.'
  },
  'collapse-all': {
    simple: 'Collapse all',
    detailed: 'Close all expanded categories to show only the top-level structure for easier navigation.'
  },
  'show-sub-tree': {
    simple: 'Show sub tree',
    detailed: 'Display a focused view of the selected category and its subcategories. Useful for working on a specific section of your document.'
  },
  'show-sub-tree-disabled': {
    simple: 'Cannot show sub tree',
    detailed: 'Select a category to view its sub tree. This option is disabled if no category is selected.'
  },
  'duplicate-as-document': {
    simple: 'Duplicate as document',
    detailed: 'Create a new document by duplicating the selected category and all its contents. This is useful for reusing or branching sections.'
  },
  'duplicate-as-document-disabled': {
    simple: 'Cannot duplicate as document',
    detailed: 'Select a category to duplicate as a new document. This option is disabled if no category is selected.'
  },
  'split-category': {
    simple: 'Split category',
    detailed: 'Divide a content category into two separate categories. This is useful for organizing content that covers multiple topics.'
  },
  'split-category-disabled': {
    simple: 'Cannot split category',
    detailed: 'Only content categories can be split. Select a category that contains content to split it.'
  },
  'group-categories': {
    simple: 'Group categories',
    detailed: 'Combine multiple selected categories into a single category. All content and subcategories will be merged.'
  },
  'group-categories-disabled': {
    simple: 'Cannot group categories',
    detailed: 'Select multiple categories to group them together. You need at least two categories selected.'
  },
  'flatten-category': {
    simple: 'Flatten category',
    detailed: 'Move all subcategories and their content to the current level, then remove the subcategories.'
  },
  'flatten-category-disabled': {
    simple: 'Cannot flatten category',
    detailed: 'This category has no subcategories to flatten. Only categories with subcategories can be flattened.'
  },
  'merge-categories': {
    simple: 'Merge categories',
    detailed: 'Combine multiple selected categories into one, keeping all content and subcategories from each.'
  },
  'merge-categories-disabled': {
    simple: 'Cannot merge categories',
    detailed: 'Select multiple categories to merge them. You need at least two categories selected.'
  },
  'move-up': {
    simple: 'Move up',
    detailed: 'Move the selected item up in the list. This changes the order within the same parent category.'
  },
  'move-up-disabled': {
    simple: 'Cannot move up',
    detailed: 'The selected item is already at the top of its list or no items are selected.'
  },
  'move-down': {
    simple: 'Move down',
    detailed: 'Move the selected item down in the list. This changes the order within the same parent category.'
  },
  'move-down-disabled': {
    simple: 'Cannot move down',
    detailed: 'The selected item is already at the bottom of its list or no items are selected.'
  },
  'cut': {
    simple: 'Cut',
    detailed: 'Remove the selected item from its current location and place it in your clipboard for pasting elsewhere.'
  },
  'cut-disabled': {
    simple: 'Cannot cut',
    detailed: 'No items are currently selected. Select one or more items to cut them.'
  },
  'copy': {
    simple: 'Copy',
    detailed: 'Create a duplicate of the selected item and place it in your clipboard for pasting elsewhere.'
  },
  'copy-disabled': {
    simple: 'Cannot copy',
    detailed: 'No items are currently selected. Select one or more items to copy them.'
  },
  'paste': {
    simple: 'Paste',
    detailed: 'Insert a previously copied or cut item at this location.'
  },
  'paste-disabled': {
    simple: 'Cannot paste',
    detailed: 'No item is currently in your clipboard. Copy or cut an item first, then paste it here.'
  },
  'rename-subcase': {
    simple: 'Rename subcase',
    detailed: 'Change the name of a subcase throughout the document. This updates all content items that use this subcase.'
  },
  'rename-subcase-disabled': {
    simple: 'Cannot rename subcase',
    detailed: 'No subcase is selected for renaming. Select a subcase from the list first.'
  },
  'manage-subcase-groups': {
    simple: 'Manage subcase groups',
    detailed: 'Organize subcases into groups for better organization and easier management.'
  },
  'manage-subcase-groups-disabled': {
    simple: 'Cannot manage subcase groups',
    detailed: 'No subcase groups are available to manage. Create some subcase groups first.'
  },
  'select-subcase': {
    simple: 'Select subcase',
    detailed: 'Choose which subcase to work with. This filters content and operations to focus on a specific subcase.'
  },
  'select-subcase-disabled': {
    simple: 'Cannot select subcase',
    detailed: 'No subcases are available to select. Add some subcases to your document first.'
  },
  
  // Content editor
  'content-subcase': {
    simple: 'Subcase',
    detailed: 'Select or enter the subcase name for this content item. Subcases help organize content by topic or section.'
  },
  'content-language': {
    simple: 'Language',
    detailed: 'Choose the language for speech recognition. This affects how the system interprets spoken words.'
  },
  'speech-recording': {
    simple: 'Start recording',
    detailed: 'Begin voice recording to add text to your content. Speak clearly and the text will appear automatically.'
  },
  'speech-recording-stop': {
    simple: 'Stop recording',
    detailed: 'Stop voice recording. The recorded text will be added to your content.'
  },
  'content-save': {
    simple: 'Save content',
    detailed: 'Save your changes to this content item. The content will be stored and available for future editing.'
  },
  'content-cancel': {
    simple: 'Cancel editing',
    detailed: 'Discard your changes and return to viewing mode. Any unsaved changes will be lost.'
  },
  'content-editor': {
    simple: 'Content editor',
    detailed: 'Edit the text content of this item. You can use formatting options, add links, and organize your content.'
  },
  'content-text-area': {
    simple: 'Content text area',
    detailed: 'Edit the main content text. You can use formatting options, add links, and organize your content with rich text editing.'
  },
  
  // Find dialog
  'find-search': {
    simple: 'Search',
    detailed: 'Search for text in categories, descriptions, and content. Use the options below to customize your search.'
  },
  'find-next': {
    simple: 'Find next',
    detailed: 'Go to the next occurrence of your search term. Use this to navigate through all matches.'
  },
  'find-previous': {
    simple: 'Find previous',
    detailed: 'Go to the previous occurrence of your search term. Use this to navigate backwards through matches.'
  },
  'find-next-category': {
    simple: 'Next category',
    detailed: 'Navigate to the next category that contains search matches. This skips to the next category regardless of how many content matches are in the current category.'
  },
  'find-previous-category': {
    simple: 'Previous category',
    detailed: 'Navigate to the previous category that contains search matches. This skips to the previous category regardless of how many content matches are in the current category.'
  },
  'find-search-names': {
    simple: 'Search in names',
    detailed: 'Include category and content names in your search. This is usually the most useful option.'
  },
  'find-search-descriptions': {
    simple: 'Search in descriptions',
    detailed: 'Include category descriptions in your search. Useful for finding categories by their purpose.'
  },
  'find-search-content': {
    simple: 'Search in content',
    detailed: 'Include the actual text content in your search. This searches through all content items.'
  },
  'find-search-mode': {
    simple: 'Search mode',
    detailed: 'Choose how to match your search terms: Any (at least one term), All (all terms), or Exact (exact phrase).'
  },
  'find-whole-word': {
    simple: 'Whole word',
    detailed: 'Only match complete words, not partial matches. For example, searching for "cat" won\'t match "category".'
  },
  'find-case-sensitive': {
    simple: 'Case sensitive',
    detailed: 'Match the exact case of letters. For example, "Cat" and "cat" will be treated as different.'
  },
  'find-subcase-filter': {
    simple: 'Filter by subcases',
    detailed: 'Limit your search to specific subcases. This helps focus your search on particular topics.'
  },
  'find-subcase-groups': {
    simple: 'Subcase groups',
    detailed: 'Select groups of subcases to include in your search. This is a quick way to filter by multiple related subcases.'
  },
  'find-subcase-individual': {
    simple: 'Individual subcases',
    detailed: 'Select specific subcases to include in your search. You can choose multiple subcases.'
  },
  'find-search-input': {
    simple: 'Search text',
    detailed: 'Enter the text you want to search for. The placeholder text changes based on your selected search mode.'
  },
  'find-search-options': {
    simple: 'Search options',
    detailed: 'Configure search settings including what to search in, match options, and search mode.'
  },
  'find-search-options-toggle': {
    simple: 'Toggle search options',
    detailed: 'Show or hide the search options panel to configure your search settings.'
  },
  'find-semantic-settings': {
    simple: 'Semantic search settings',
    detailed: 'Configure settings for semantic search including similarity threshold and score display.'
  },
  'find-similarity-threshold': {
    simple: 'Threshold',
    detailed: 'Adjust how similar results must be to your search query. Lower values show more results, higher values show only very similar results.'
  },
  'find-show-similarity-score': {
    simple: 'Show scores',
    detailed: 'Display similarity percentages for semantic search results to help you understand how well each result matches your query.'
  },
  'find-subcase-selection': {
    simple: 'Subcase selection',
    detailed: 'Choose which subcases to include in your search. You can select groups or individual subcases.'
  },
  'find-subcase-selection-toggle': {
    simple: 'Toggle subcase selection',
    detailed: 'Show or hide the subcase selection panel to filter your search by specific subcases.'
  },
  'find-subcase-select-all': {
    simple: 'Select all subcases',
    detailed: 'Include all available subcases in your search. This removes subcase filtering.'
  },
  'find-subcase-group': {
    simple: 'Subcase group',
    detailed: 'Select a group of related subcases to include in your search. Only one group can be selected at a time.'
  },
  'find-subcase-individual-item': {
    simple: 'Individual subcase',
    detailed: 'Select a specific subcase to include in your search. You can select multiple individual subcases.'
  },
  'find-close': {
    simple: 'Close find dialog',
    detailed: 'Close the find dialog and return to normal document view.'
  },
  'find-help': {
    simple: 'Find dialog help',
    detailed: 'View keyboard shortcuts and usage tips for the find dialog.'
  },
  
  // Show sub tree dialog
  'show-subtree-subcases': {
    simple: 'Select subcases',
    detailed: 'Choose which subcases to include in the sub tree view. This filters the content shown in the focused view.'
  },
  'show-subtree-select-all': {
    simple: 'Select all',
    detailed: 'Include all subcases in the sub tree view. This shows all content in the selected category.'
  },
  'show-subtree-show': {
    simple: 'Show sub tree',
    detailed: 'Display the focused view of the selected category with the chosen subcases. This creates a focused workspace.'
  },
  
  // Ask AI dialog
  'ask-ai-prompt': {
    simple: 'AI prompt',
    detailed: 'Enter your question or request for the AI. Be specific about what you want to know or what you want the AI to help you with.'
  },
  'ask-ai-send': {
    simple: 'Send to AI',
    detailed: 'Submit your question to the AI assistant. The AI will analyze your document and provide a helpful response.'
  },
  'ask-ai-clear': {
    simple: 'Clear conversation',
    detailed: 'Start a new conversation with the AI. This will clear the current chat history.'
  },
  'ask-ai-export': {
    simple: 'Export conversation',
    detailed: 'Save the current AI conversation to a file for future reference or sharing.'
  },
  
  // Semantic search
  'semantic-search-query': {
    simple: 'Search query',
    detailed: 'Enter your search question in natural language. The AI will understand the meaning and find relevant content.'
  },
  'semantic-clear-history': {
    simple: 'Clear conversation',
    detailed: 'Delete all previous messages in this conversation. This will start a fresh conversation with the AI assistant.'
  },
  'semantic-settings': {
    simple: 'Settings',
    detailed: 'Configure AI assistant settings including similarity threshold, maximum results, and display options for source texts and similarity scores.'
  },
  'semantic-close': {
    simple: 'Close',
    detailed: 'Close the AI assistant window and return to the main document view. Your conversation history will be saved.'
  },
  'semantic-send': {
    simple: 'Send',
    detailed: 'Send your question to the AI assistant. The AI will analyze your document and provide a helpful response based on the content.'
  },
  'semantic-similarity-threshold': {
    simple: 'Threshold',
    detailed: 'Adjust how similar content must be to your question for the AI to include it. Lower values (0.1-0.3) include more content, higher values (0.7-0.9) include only very relevant content.'
  },
  'semantic-max-results': {
    simple: 'Max results',
    detailed: 'Set the maximum number of content items to send to the AI for context. More items provide more context but may slow down responses. Recommended: 3-5 for focused answers, 7-10 for comprehensive responses.'
  },
  'semantic-auto-clear-history': {
    simple: 'Auto clear',
    detailed: 'Automatically clear conversation history when switching documents. This helps keep conversations focused on the current document and prevents confusion between different documents.'
  },
  'semantic-show-sources': {
    simple: 'Show sources',
    detailed: 'Display the source content that the AI used to generate its response. This helps you understand where the information came from and verify the accuracy of the AI\'s answer.'
  },
  'semantic-show-similarity-score': {
    simple: 'Show scores',
    detailed: 'Display similarity percentages for source texts to show how relevant each piece of content was to your question. Higher percentages indicate more relevant content.'
  },
  'semantic-settings-close': {
    simple: 'Close settings',
    detailed: 'Close the settings panel and return to the AI conversation view. Your settings will be saved automatically.'
  },
  'semantic-question-input': {
    simple: 'Ask question',
    detailed: 'Enter your question about the document in natural language. The AI will understand the meaning and find relevant content to provide a helpful answer.'
  },
  
  // Duplicate category as document dialog
  'duplicate-category-document-name': {
    simple: 'New document name',
    detailed: 'Enter a name for the new document that will be created from the selected category and its contents.'
  },
  'duplicate-category-select-categories': {
    simple: 'Select categories',
    detailed: 'Choose which categories to include in the new document. Categories must have at least 2 subcategories selected.'
  },
  'duplicate-category-category-tree': {
    simple: 'Category tree',
    detailed: 'Browse and select categories from the tree structure. Check the boxes to include categories in the new document.'
  },
  'duplicate-category-select-subcases': {
    simple: 'Select subcases',
    detailed: 'Choose which subcases to include in the new document. You can select groups or individual subcases.'
  },
  'duplicate-category-subcase-selection-toggle': {
    simple: 'Toggle subcase selection',
    detailed: 'Show or hide the subcase selection panel to choose which subcases to include.'
  },
  'duplicate-category-subcase-groups': {
    simple: 'Subcase groups',
    detailed: 'Select groups of related subcases to include in the new document. Only one group can be selected at a time.'
  },
  'duplicate-category-subcase-individual': {
    simple: 'Individual subcases',
    detailed: 'Select specific subcases to include in the new document. You can choose multiple individual subcases.'
  },
  'duplicate-category-subcase-select-all': {
    simple: 'Select all subcases',
    detailed: 'Include all available subcases in the new document. This removes subcase filtering.'
  },
  'duplicate-category-subcase-individual-item': {
    simple: 'Individual subcase',
    detailed: 'Select a specific subcase to include in the new document. You can select multiple individual subcases.'
  },
  'duplicate-category-cancel': {
    simple: 'Cancel',
    detailed: 'Close the dialog without creating a new document. All selections will be discarded.'
  },
  'duplicate-category-confirm': {
    simple: 'Duplicate as document',
    detailed: 'Create a new document with the selected categories and subcases. The new document will be added to your document list.'
  },
  
  // SubTreeView
  'subtree-search-category': {
    simple: 'Search categories',
    detailed: 'Include category names in the search. When enabled, category names will be searched and highlighted when they match your search terms.'
  },
  'subtree-search-description': {
    simple: 'Search descriptions',
    detailed: 'Include category descriptions in the search. When enabled, category descriptions will be searched and highlighted when they match your search terms.'
  },
  'subtree-search-subcase': {
    simple: 'Search subcases',
    detailed: 'Include subcase names in the search. When enabled, subcase names will be searched and highlighted when they match your search terms.'
  },
  'subtree-search-content': {
    simple: 'Search content',
    detailed: 'Include content text in the search. When enabled, the actual content text will be searched and highlighted when it matches your search terms.'
  },
  'subtree-show-sources': {
    simple: 'Show source texts',
    detailed: 'Display source texts for content items. When enabled, you can expand content items to see the original source texts that were used to generate the content.'
  },
  'subtree-search-input': {
    simple: 'Search text',
    detailed: 'Enter search terms to find matching content. You can search for multiple words or use quotes for exact phrases. The search will highlight all matches in the tree view.'
  },
  'subtree-clear-search': {
    simple: 'Clear search',
    detailed: 'Clear the search field and remove all search highlighting from the tree view.'
  },
  'subtree-case-sensitive': {
    simple: 'Case sensitive',
    detailed: 'Match the exact case of letters when searching. For example, "Cat" and "cat" will be treated as different when enabled.'
  },
  'subtree-whole-word': {
    simple: 'Whole word only',
    detailed: 'Only match complete words. For example, searching for "cat" will not match "category" when this option is enabled.'
  },
  'subtree-previous-match': {
    simple: 'Previous match',
    detailed: 'Navigate to the previous search match in the tree view. This will scroll to and highlight the previous occurrence of your search terms.'
  },
  'subtree-next-match': {
    simple: 'Next match',
    detailed: 'Navigate to the next search match in the tree view. This will scroll to and highlight the next occurrence of your search terms.'
  },
  'subtree-expand-sources': {
    simple: 'Toggle source texts',
    detailed: 'Expand or collapse the source texts for this content item. Source texts show the original text that was used to generate this content.'
  },
  
  // Common dialog buttons
  'cancel': {
    simple: 'Cancel',
    detailed: 'Close the dialog without making any changes. All unsaved changes will be discarded.'
  },
  'duplicate': {
    simple: 'Duplicate',
    detailed: 'Create a copy of the selected item with the specified settings. The duplicate will be created immediately.'
  },
  'duplicate-document-select-all': {
    simple: 'Select all subcases',
    detailed: 'Include all subcases in the duplicate document. This removes subcase filtering and includes all available subcases.'
  }
};

export type HelpContentKey = keyof typeof helpContent; 